import React, { useState } from 'react'
import { Button } from 'antd'
import {
  GOODS_RECEIPTING_LEARN_MORE_BODY,
  GOODS_RECEIPTING_LEARN_MORE_TITLE,
  buildGoodsReceiptRequiredCopy,
} from 'src/utils/goodsReceiptReorderCopy'

/**
 * Helpful (not punitive) body for the checkout goods-receipt block modal.
 */
const GoodsReceiptRequiredModalContent = ({
  supplierTitle,
  backendMessage,
}) => {
  const [showLearnMore, setShowLearnMore] = useState(false)
  const copy = buildGoodsReceiptRequiredCopy(supplierTitle, backendMessage)

  return (
    <div>
      <p style={{ marginBottom: 12 }}>{copy.headline}</p>
      <p style={{ marginBottom: 12, color: '#595959' }}>{copy.reason}</p>
      <p style={{ marginBottom: 12 }}>
        <strong>{copy.basketNote}</strong>
      </p>
      <p style={{ marginBottom: 16 }}>{copy.nextStep}</p>
      <Button
        type='link'
        style={{
          padding: 0,
          height: 'auto',
          marginBottom: showLearnMore ? 8 : 0,
        }}
        onClick={() => setShowLearnMore(open => !open)}
      >
        {showLearnMore ? 'Hide' : 'Learn More'} —{' '}
        {GOODS_RECEIPTING_LEARN_MORE_TITLE}
      </Button>
      {showLearnMore && (
        <div
          style={{
            marginTop: 8,
            padding: '12px 14px',
            background: '#fafafa',
            borderRadius: 6,
            border: '1px solid #f0f0f0',
            fontSize: 13,
            color: '#595959',
            lineHeight: 1.55,
          }}
        >
          {GOODS_RECEIPTING_LEARN_MORE_BODY.map(line => (
            <p key={line} style={{ marginBottom: 6 }}>
              {line}
            </p>
          ))}
        </div>
      )}
    </div>
  )
}

export default GoodsReceiptRequiredModalContent
